import * as React from "react";

class AppVersionInfo extends React.Component {
    /* eslint-disable */
    constructor(props) {
        super(props);
    }

    /* eslint-enable */
    state = {
        envReactVersion: "",
        envTeamsAppVersion: ""
    }

    componentDidMount() {
        // get react- and teamsapp-version from process-data (compiled .env-file at build-time in azure-devops)
        this.setState({
            envReactVersion: process.env.APPVERSION ?? "undefined",
            envTeamsAppVersion: process.env.MICROSOFT_APP_VERSION ?? "undefined"
        });
    }

    componentWillUnmount() {
        console.log("start componentWillUnmount");
    }

    onClickVersion = (): void => {
        window.location.href = "/tabAppInfo/";
    }

    render() {
        return (
            <span
                className="cpbxVersionText"
                title={"React-Version ist '" + this.state.envReactVersion +
                    "', Teams-App-Version ist '" + this.state.envTeamsAppVersion +
                    "'. Klick hier für weitere Informationen"}
                onClick={this.onClickVersion}
            >Version {this.state.envReactVersion}</span>
        );
    }
}

export default AppVersionInfo;
